import React, { useMemo } from 'react'
import { useFragment, graphql } from 'react-relay'

import { ImageProps, getTokenValue, Token, styled } from 'tamagui'

import { Image } from '../Image'

import { IMAGEKIT_URL } from '../../data/config/url'

import { GuildPrimaryPhotoNew_guild$key } from './__generated__/GuildPrimaryPhotoNew_guild.graphql'

const GuildPrimaryPhotoFrame = styled(Image, {
  name: 'GuildPrimaryPhoto',
  backgroundColor: '$grey0',
  borderRadius: '$2',
  borderWidth: 1,
  borderColor: 'rgba(19, 0, 102, 0.16)',
  boxShadow: '0 0 0 1px #FFFFFF',
})

// GuildCardPrimaryPhoto: {
//   backgroundColor: 'grey.0',

//   borderRadius: 4,
//   borderWidth: 0.25,
//   borderColor: 'rgba(19, 0, 102, 0.16)',

//   variants: {
//     inCard: {
//       marginLeft: 4,
//       marginRight: 4,
//       boxShadow: '0 0 0 3px #FFFFFF',
//     },
//     large: {
//       boxShadow: '0 0 0 3px #FFFFFF',
//     },
//     small: {
//       borderRadius: 2,
//       boxShadow: '0 0 0 1px #FFFFFF',
//     },
//   },
// },

export const GuildPrimaryPhoto = GuildPrimaryPhotoFrame.styleable<
  HTMLImageElement,
  {
    guild: GuildPrimaryPhotoNew_guild$key
    size: Token
  }
>(({ guild, size = '$5', ...props }, ref) => {
  const data = useFragment(
    graphql`
      fragment GuildPrimaryPhotoNew_guild on Guild {
        rowId

        primaryPhoto {
          rowId
          contentType
        }
      }
    `,
    guild
  )

  const parsedSize = useMemo(() => {
    return getTokenValue(size, 'size')
  }, [size])

  if (!data.primaryPhoto) {
    return null
  }

  return (
    <GuildPrimaryPhotoFrame
      {...props}
      ref={ref}
      src={`${IMAGEKIT_URL}/tr:w-${parsedSize},h-${parsedSize},dpr-3/${
        data.primaryPhoto.rowId
      }.${data.primaryPhoto.contentType.toLowerCase()}`}
      width={parsedSize}
      height={parsedSize}
    />
  )
})
